// _forms/_shared/components/DateSelectors.jsx
import React, { useState, useEffect } from 'react';
import './DateSelectors.css';

const DateSelectors = ({
  value,
  onChange,
  required = false,
  className = '',
  disabled = false,
  placeholder = 'Selecciona una fecha',
}) => {
  const [day, setDay] = useState('');
  const [month, setMonth] = useState('');
  const [year, setYear] = useState('');
  const [isComplete, setIsComplete] = useState(false);

  const days = Array.from({ length: 31 }, (_, i) => i + 1);
  const months = [
    { value: '01', label: 'Enero' },
    { value: '02', label: 'Febrero' },
    { value: '03', label: 'Marzo' },
    { value: '04', label: 'Abril' },
    { value: '05', label: 'Mayo' },
    { value: '06', label: 'Junio' },
    { value: '07', label: 'Julio' },
    { value: '08', label: 'Agosto' },
    { value: '09', label: 'Septiembre' },
    { value: '10', label: 'Octubre' },
    { value: '11', label: 'Noviembre' },
    { value: '12', label: 'Diciembre' },
  ];
  const currentYear = new Date().getFullYear();
  const years = Array.from({ length: currentYear - 1900 + 1 }, (_, i) => currentYear - i);

  useEffect(() => {
    if (value) {
      try {
        if (typeof value === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(value)) {
          const [y, m, d] = value.split('-');
          setDay(d);
          setMonth(m);
          setYear(y);
          setIsComplete(true);
          return;
        }
        const date = new Date(value);
        if (!isNaN(date.getTime())) {
          setDay(String(date.getDate()).padStart(2, '0'));
          setMonth(String(date.getMonth() + 1).padStart(2, '0'));
          setYear(String(date.getFullYear()));
          setIsComplete(true);
        }
      } catch {
        setIsComplete(false);
      }
    } else {
      setDay('');
      setMonth('');
      setYear('');
      setIsComplete(false);
    }
  }, [value]);

  const emitChange = (d, m, y) => {
    if (!d || !m || !y) {
      onChange('');
      setIsComplete(false);
      return;
    }

    const dayNum = parseInt(d, 10);
    const monthNum = parseInt(m, 10);
    const yearNum = parseInt(y, 10);

    const date = new Date(yearNum, monthNum - 1, dayNum);

    if (!isNaN(date.getTime())) {
      const createdYear = date.getFullYear();
      const createdMonth = date.getMonth() + 1;
      const createdDay = date.getDate();

      if (createdYear === yearNum && createdMonth === monthNum && createdDay === dayNum) {
        const dateStr = `${yearNum}-${String(monthNum).padStart(2, '0')}-${String(dayNum).padStart(2, '0')}`;
        setIsComplete(true);
        onChange(dateStr);
        return;
      }
    }

    setIsComplete(false);
    onChange('');
  };

  const handleDayChange = (e) => {
    const newDay = e.target.value;
    setDay(newDay);
    emitChange(newDay, month, year);
  };

  const handleMonthChange = (e) => {
    const newMonth = e.target.value;
    setMonth(newMonth);
    emitChange(day, newMonth, year);
  };

  const handleYearChange = (e) => {
    const newYear = e.target.value;
    setYear(newYear);
    emitChange(day, month, newYear);
  };

  const hasError = required && !isComplete && (day || month || year);

  return (
    <div className={`date-selectors ${className} ${hasError ? 'has-error' : ''}`}>
      <select
        value={day}
        onChange={handleDayChange}
        disabled={disabled}
        className="date-select day-select"
        required={required}
      >
        <option value="">Día</option>
        {days.map((d) => (
          <option key={d} value={String(d).padStart(2, '0')}>
            {d}
          </option>
        ))}
      </select>

      <select
        value={month}
        onChange={handleMonthChange}
        disabled={disabled}
        className="date-select month-select"
        required={required}
      >
        <option value="">Mes</option>
        {months.map((m) => (
          <option key={m.value} value={m.value}>
            {m.label}
          </option>
        ))}
      </select>

      <select
        value={year}
        onChange={handleYearChange}
        disabled={disabled}
        className="date-select year-select"
        required={required}
      >
        <option value="">Año</option>
        {years.map((y) => (
          <option key={y} value={String(y)}>
            {y}
          </option>
        ))}
      </select>

      {hasError && (
        <span className="date-selectors-error">Selecciona una fecha completa</span>
      )}
    </div>
  );
};

export default DateSelectors;